const remediationConstants = {
  maxTextLength: 255,
};

export default remediationConstants;
